import { Grid, Paper } from "@mui/material";
import { GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { BilletsYardStatus } from "../../models/BilletsYardStatus";
import { useYardStatusColumns } from "../hooks/useYardStatusColumns";
import { useResize } from "@/utils/useResize";
import { getResponsiveTableStyles } from "@/utils/responsive-utils";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

type Props = {
  loadingGrid: boolean;
  rows: BilletsYardStatus[];
  onGridReady?: (params: GridReadyEvent) => void;
};

export const BilletsYardStatusTable = ({
  loadingGrid,
  rows,
  onGridReady,
}: Props) => {
  const gridRef = useRef<AgGridReact>(null);
  const { height } = useResize();

  const tableStyles = {
    padding: 10,
    height: height - 200,
    minHeight: height - 200,
    width: "100%",
  };

  const { columns } = useYardStatusColumns();

  return (
    <>
      <Grid container>
        <Grid
          item
          component={Paper}
          elevation={3}
          md={12}
          xs={12}
          style={tableStyles}
        >
          <AgGridReact
            ref={gridRef}
            rowData={rows}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            loading={loadingGrid}
            onGridReady={onGridReady}
            {...defaultGridOptions}
          />
        </Grid>
      </Grid>
    </>
  );
};
